import { css } from '@emotion/css';

export const editButtonStyles = css`
  :hover {
    .edit {
      color: var(--text-interactive-01);
    }
  }
`;

export const deleteButtonStyles = css`
  :hover {
    .delete {
      color: var(--icon-error);
    }
  }
`;

export const linkStyles = css`
  width: 19.6rem;
`;
